"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeTimeSection = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../styled/styles");
var datetime_1 = require("@blueprintjs/datetime");
var DateRangeTimeSection = function (props) {
    var startTime = props.startTime, endTime = props.endTime, disabled = props.disabled;
    var startValue = startTime.value, startOnChange = startTime.onChange, startUseAmPm = startTime.useAmPm, startPrecision = startTime.precision;
    var endValue = endTime.value, endOnChange = endTime.onChange, endUseAmPm = endTime.useAmPm, endPrecision = endTime.precision;
    return (react_1.default.createElement(styles_1.DateRangeTimeSectionBody, null,
        react_1.default.createElement(datetime_1.TimePicker, { value: startValue, useAmPm: startUseAmPm || false, precision: startPrecision || 'second', onChange: startOnChange, disabled: disabled }),
        react_1.default.createElement(datetime_1.TimePicker, { value: endValue, useAmPm: endUseAmPm || false, precision: endPrecision || 'second', onChange: endOnChange, disabled: disabled })));
};
exports.DateRangeTimeSection = DateRangeTimeSection;
